<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10">
        <simple-wizard>
          <template slot="header">
            <h2 class="card-title">Laporan Penyiasatan Kemalangan</h2>
            <h3
              class="description"
            >Please fill in all the required details to complete the investigation report.</h3>
          </template>

          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label">
              <i class="tim-icons icon-single-02"></i>
              <p>Incident List</p>
            </template>
            <first-step ref="step1" @on-validated="onStepValidated"></first-step>
          </wizard-tab>

          <!-- <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              <i class="tim-icons icon-square-pin"></i>
              <p>Incident Report</p>
            </template>
            <second-step ref="step2" @on-validated="onStepValidated"></second-step>
          </wizard-tab> -->
          
          <wizard-tab :before-change="() => validateStep('step3')">
            <template slot="label">
              <i class="tim-icons icon-square-pin"></i>
              <p>Section A</p>
            </template>
            <third-step ref="step3" @on-validated="onStepValidated"></third-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step4')">
            <template slot="label">
              <i class="tim-icons icon-square-pin"></i>
              <p>Section B</p>
            </template>
            <fourth-step ref="step4" @on-validated="onStepValidated"></fourth-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step5')">
            <template slot="label">
              <i class="tim-icons icon-square-pin"></i>
              <p>Section C</p>
            </template>
            <fifth-step ref="step5" @on-validated="onStepValidated"></fifth-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step6')">
            <template slot="label">
              <i class="tim-icons icon-square-pin"></i>
              <p>Section D</p>
            </template>
            <sixth-step ref="step6" @on-validated="onStepValidated"></sixth-step>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from "./WizardInvestigation/FirstStep.vue";
import SecondStep from "./WizardInvestigation/SecondStep.vue";
import ThirdStep from "./WizardInvestigation/ThirdStep.vue";
import FourthStep from "./WizardInvestigation/FourthStep.vue";
import FifthStep from "./WizardInvestigation/FifthStep.vue";
import SixthStep from "./WizardInvestigation/SixthStep.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    FifthStep,
    SixthStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      swal("Good job!", "You clicked the finish button!", "success");
    }
  }
};
</script>
<style lang="scss" scoped>
p {
  width: 150%;
}
</style>